import axios from "axios";

export function getCategories(s: string = '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/category';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getCategoryOptions(s: string = '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/category/options';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getCategoriesSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/category/' + id;
    return axios.get(endpointUrl, { headers: headers } );
}

export function createCategory(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/category';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateCategory(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/category';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteCategory(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/category/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}